import { Inmate } from '@reliance/types/models/Inmate';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Form } from 'react-final-form';
import api from '../common/api';
import Checkbox from '../form/Checkbox';

type RecordRestrictionEditModalProps = {
  inmate: Inmate;
  onClose(success?: boolean): any;
};

const RecordRestrictionEditModal: React.FC<RecordRestrictionEditModalProps> = (props) => {
  const save = (formData) => {
    let recordRestrictions = 0;

    if (formData.importModify) {
      recordRestrictions = recordRestrictions | (1);
    }
    if (formData.importDelete) {
      recordRestrictions = recordRestrictions | (1<<1);
    }
    if (formData.ignoreItdsPin) {
      recordRestrictions = recordRestrictions | (1<<2);
    }
    if (formData.ignoreItdsDelete) {
      recordRestrictions = recordRestrictions | (1<<3);
    }

    return api.put(`/inmate/${props.inmate.account}?facilityId=${props.inmate.facility.id}`, { recordRestrictions })
      .then(() => props.onClose(true));
  };

  const initialValues = {
    importModify: props.inmate.recordRestrictions & (1),
    importDelete: props.inmate.recordRestrictions & (1<<1),
    ignoreItdsPin: props.inmate.recordRestrictions & (1<<2),
    ignoreItdsDelete: props.inmate.recordRestrictions & (1<<3)
  };

  return (
    <Modal show={true} onHide={props.onClose}>
      <Form
        initialValues={initialValues}
        keepDirtyOnReinitialize={true}
        onSubmit={save}
        render={({ handleSubmit, submitting, hasValidationErrors }) =>
        <form onSubmit={handleSubmit}>
          <Modal.Header>Record Restrictions</Modal.Header>
          <Modal.Body>
            <Checkbox
              name="importModify"
              label="Import - Modify" />
            <Checkbox
              name="importDelete"
              label="Import - Delete" />
            <Checkbox
              name="ignoreItdsPin"
              label="Ignore ITDS PIN" />
            <Checkbox
              name="ignoreItdsDelete"
              label="Ignore ITDS Delete" />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="default"
              type="button"
              disabled={submitting}
              onClick={() => props.onClose(false)}>
              Cancel
            </Button>
            <Button
              variant="primary"
              disabled={submitting || hasValidationErrors}
              type="submit">
              Save
            </Button>
          </Modal.Footer>
        </form>
      } />
    </Modal>
  );
};

export default RecordRestrictionEditModal;
